<div class="bw-dialog">

  <lib-page-header screenName="Support" title="Support">
    <mat-icon icon>support_agent</mat-icon>
    <ng-container subtitle>
      <span>Include this information when contacting support</span>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">

    <div class="info-card">
      <div class="info-row">
        <mat-icon class="info-icon">person</mat-icon>
        <label>User</label>
        <span>{{ data.userEmail }}</span>
      </div>
      <div class="info-row">
        <mat-icon class="info-icon">business</mat-icon>
        <label>Tenant</label>
        <span>{{ data.tenant }}</span>
      </div>
      <div class="info-row">
        <mat-icon class="info-icon">verified</mat-icon>
        <label>Version</label>
        <span>{{ data.appVersion || 'N/A' }}</span>
      </div>
    </div>

    <div class="session-card">
      <div class="session-label">
        <mat-icon class="info-icon">fingerprint</mat-icon>
        <label>Session ID</label>
      </div>
      <div class="session-value">
        <code>{{ data.sessionId }}</code>
        <button mat-icon-button (click)="copySessionId()" class="copy-btn"
                [matTooltip]="copied ? 'Copied!' : 'Copy to clipboard'">
          <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </div>
      <span class="session-hint">Include this ID when contacting support for faster diagnosis.</span>
    </div>

  </div>


</div>
